export default function buildHtmlList(
  arrayOfListItems,
  listClasses = '',
  itemClasses = ''
) {
  const listElemets = arrayOfListItems
    .map((item) => `<li class="${itemClasses}">${item}</li>`)
    .join('');

  return `<ul class="${listClasses}">${listElemets}</ul>`;
}
